import React from 'react';
import { observer } from 'mobx-react';
import uniqueId from 'lodash/uniqueId';
import classNames from 'classnames';
import { Icon } from 'components/Icon';
import * as constants from 'Constants';
import * as utils from 'Utils';
import * as aovUtils from 'stores/AovProgressBar/Utils';
import pageStore from 'stores/AovProgressBar/PageStore';
import styles from './styles';
import './styles.scss';



@observer
class DiscountItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { discount } = this.props;

    return (
      <div className="ov-discount-item">
        <Icon.Bp icon="tick-circle" /> <div className="ov-item-text" dangerouslySetInnerHTML={{__html: discount.descriptorHtml}}></div>
      </div>
    )
  }
};



@observer
class AovProgressBar extends React.Component {
  constructor(props) {
    super(props);
  }

  updateAppElementStyles = () => {
    const { aov } = this.props;
    aovUtils.updateAppElementStyles(aov);
  };

  updateCartAmount = (amount) => {
    const { aov } = this.props;
    aov.setCartAmount(amount);
  };

  render() {
    const { aov } = this.props;

    this.updateAppElementStyles();
    if (!aov.display || !pageStore.display) return null;

    const className = classNames(
      "ov-aov-progress-bar"
    );

    return (
      <div
        className={className}
      >
        {aov.completed ? (
          <div className="ov-cta" dangerouslySetInnerHTML={{__html: aov.completionNoteHtml}}></div>
        ): (
          <div className="ov-cta" dangerouslySetInnerHTML={{__html: aov.ctaHtml}}></div>
        )}

        <div className="ov-progress-bar">
          <div className="ov-progress-bar-current" style={{width: `${aov.barPct}%`}}></div>
        </div>

        {aov.eligibleDiscounts.length > 0 ? (
          <div className="ov-discounts">
            {aov.eligibleDiscounts.map((discount) =>
              <DiscountItem
                key={uniqueId()}
                discount={discount}
              />
            )}
          </div>
        ): null}
      </div>
    )
  }
};


export default AovProgressBar;


